import { Typography, Flex } from '@paintscout/ui'
import { escapeHref } from '@paintscout/util/util'
import React from 'react'
import { AuthCallback } from 'react-auth0'
import { Link, Redirect } from 'react-router-dom'

/**
 * After auth0 authenticates it will redirect here
 */
function LoginCallback() {
  return (
    <div style={{ height: '100vh', width: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <AuthCallback>
        {({ loading, error, previousUrl }) => {
          if (error) {
            if (error.error === 'unauthorized') {
              // @ts-ignore - error is on error_description field
              const msg = error?.error_description ?? 'Unauthorized'
              return (
                <Flex direction="column" align="center">
                  <Typography variant="h2" gutterBottom>
                    {msg}
                  </Typography>
                  <Typography>
                    <Link to="/logout">Logout</Link>
                  </Typography>
                </Flex>
              )
            }

            console.error(error)
            return (
              <Typography variant="body1">
                An unexpected error occurred. <Link to="/logout">Click here to try logging in again</Link>
              </Typography>
            )
          }

          if (loading) {
            return null
          }

          // Branch deploys live at /_branch/{name}/ — use a hard redirect so the
          // browser loads the branch app instead of trying to route within the canonical app.
          if (previousUrl && previousUrl.startsWith('/_branch/')) {
            window.location.href = escapeHref(previousUrl)
            return null
          }

          return <Redirect to={previousUrl || '/'} />
        }}
      </AuthCallback>
    </div>
  )
}

export default LoginCallback
